export default __webpack_public_path__ + "static/media/visual_1.df8f0502.png";